import React, { FC, useEffect, useState } from 'react'
import styles from './OrderedDishesListCard.module.css'
import noImage from '../../assets/img/no-image.jpg'
import arrow from '../../assets/icons/IconArrowDownBlue.svg'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import trashGray from '../../assets/icons/trashGray.svg'
import {
  createOrder,
  deleteCurrentPlaceOrders,
  removeProductFromOrder,
  updateOrder,
} from '../../redux/actions/ordersAction'
import { getCurrentClaim } from '../../redux/actions/claimsAction'
import CustomButton from '../UI/CustomButton/CustomButton'
import {
  clearOrder,
  removeOrderDetail,
  updateOrderDetailQuantity,
} from '../../redux/reducers/claims/claimsSlice'
import { useToast } from '../../context/ToastContext'
import CustomModal from '../UI/CustomModal/CustomModal'
import CreateCommentModal from '../CreateCommentModal/CreateCommentModal'
export type DishType = {
  id: number
  name: string
  description: string
  weight: string
  measurement: string
  price: string
  images: string[]
  logo: string | null
  quantity: number
  createdAt: string
  comment?: string
}

export type OrderedDishesListCardPropsType = {
  dishesCollection: DishType[]
}

const OrderedDishesListCard: FC<OrderedDishesListCardPropsType> = ({ dishesCollection }) => {
  const { token } = useAppSelector((state) => state.auth)
  const [visibleCreateComment, setVisibleCreateComment] = useState<boolean>(false)
  const [selectedProduct, setSelectedProduct] = useState<DishType>({} as DishType)
  const [openMore, setOpenMore] = useState(false)
  const { showSuccess, showError } = useToast()
  const { currentClaim } = useAppSelector((state) => state.claims)
  const [discountTotal, setDiscountTotal] = useState(0)
  const [serviceFeeTotal, setserviceFeeTotal] = useState(0)

  const handleRemoveProduct = async (id: any) => {
    try {
      dispatch(removeOrderDetail({ claimId: currentClaim.id, productId: id }))
      if (currentClaim.order.id) {
        await dispatch(
          removeProductFromOrder({ orderId: currentClaim.order.id, productId: id, token }),
        )
      }
      showSuccess('Товар удален из заказа')
    } catch (error) {
      showError('Произошла ошибка при удалении товара')
    }

    const searchParams = new URLSearchParams(location.search)
    const claimId = searchParams.get('id')
    if (claimId) {
      dispatch(getCurrentClaim({ claimId, token }))
    }
    if (claimId) {
      dispatch(getCurrentClaim({ claimId, token }))
    }
  }

  const dispatch = useAppDispatch()

  const discount = currentClaim?.discountAmount || currentClaim?.discountPercent

  const serviceFee = currentClaim?.serviceFeeAmount || currentClaim?.serviceFeePercent
  const corkFee = currentClaim?.corkFeeAmount || currentClaim?.corkFeePercent

  useEffect(() => {
    if (discount == currentClaim?.discountAmount) {
      setDiscountTotal(currentClaim?.order?.price - (currentClaim?.order?.price - Number(discount)))
    }
    if (discount == currentClaim?.discountPercent) {
      setDiscountTotal(
        -(
          currentClaim?.order?.price -
          currentClaim?.order?.price -
          (currentClaim?.order?.price * Number(discount)) / 100
        ),
      )
    }
    if (serviceFee == currentClaim?.serviceFeeAmount) {
      setserviceFeeTotal(
        currentClaim?.order?.price + Number(serviceFee) - currentClaim?.order?.price,
      )
    }
    if (serviceFee == currentClaim?.serviceFeePercent) {
      setserviceFeeTotal(
        currentClaim?.order?.price +
          Math.round((currentClaim?.order?.price * Number(serviceFee)) / 100) -
          currentClaim?.order?.price,
      )
    }
  }, [dispatch, location, currentClaim])

  const onCountChange = (e: React.ChangeEvent<HTMLInputElement>, currentOrder: any) => {
    const val = Number(e.target.value)
    if (val >= 1) {
      dispatch(
        updateOrderDetailQuantity({
          claimId: Number(currentClaim.id),
          orderDetailId: currentOrder?.productId ?? 0,
          newQuantity: val,
        }),
      )
    }
  }

  const handleIncrease = (currentOrder: any) => {
    dispatch(
      updateOrderDetailQuantity({
        claimId: Number(currentClaim.id),
        orderDetailId: currentOrder.productId ?? 0,
        newQuantity: currentOrder.quantity + 1,
      }),
    )
  }

  const handleDecrease = (currentOrder: any) => {
    if (currentOrder && currentOrder.quantity > 1) {
      dispatch(
        updateOrderDetailQuantity({
          claimId: Number(currentClaim.id),
          orderDetailId: currentOrder.productId,
          newQuantity: currentOrder.quantity - 1,
        }),
      )
    }
  }

  const handleSubmit = async () => {
    if (currentClaim.order?.id) {
      const resultAction = await dispatch(
        updateOrder({
          orderId: currentClaim.order.id,
          data: { products: currentClaim.order.orderDetails },
          token,
        }),
      )
      if (updateOrder.rejected.match(resultAction)) {
        showError('Произошла ошибка при изменении заказа')
      } else {
        dispatch(getCurrentClaim({ claimId: String(currentClaim.id) ?? '', token }))
        showSuccess('Заказ успешно изменен')
      }
    } else {
      const resultAction = await dispatch(
        createOrder({
          data: {
            placeRequestId: Number(currentClaim.id),
            products: currentClaim.order?.orderDetails,
          },
          token,
        }),
      )
      if (createOrder.rejected.match(resultAction)) {
        showError('Произошла ошибка при создании заказа')
      } else {
        showSuccess('Заказ успешно создан')
        dispatch(getCurrentClaim({ claimId: String(currentClaim.id) ?? '', token }))
      }
    }
  }

  const handleDeleteOrder = async () => {
    const resultAction = await dispatch(
      deleteCurrentPlaceOrders({ orderId: currentClaim.order.id, token }),
    )
    if (deleteCurrentPlaceOrders.rejected.match(resultAction)) {
      showError('Произошла ошибка при удалении заказа')
    } else {
      dispatch(clearOrder({ claimId: currentClaim.id }))

      showSuccess('Заказ успешно удален')
    }
  }

  return (
    <div className={styles.OrderedDishesListCard}>
      <CustomModal visible={visibleCreateComment} setVisible={setVisibleCreateComment}>
        <CreateCommentModal
          selectedProduct={selectedProduct}
          onClose={() => setVisibleCreateComment(false)}
        />
      </CustomModal>
      <div className={styles.formContainer}>
        <h1 className={styles.title}>Состав Заказа</h1>
        <div className={styles.content}>
          {dishesCollection.map((dish) => (
            <div key={dish.id} className={styles.dishCard}>
              <div className={styles.nameContainer}>
                <div className={styles.left}>
                  {dish?.images?.length > 0 ? (
                    <div className={styles.imagesContainer}>
                      <img
                        src={`${process.env.REACT_APP_BASE_URL_IMAGES}${dish.images[0]}`}
                        alt={''}
                        className={styles.dishImage}
                      />
                    </div>
                  ) : (
                    <div className={styles.imagesContainer}>
                      <img src={noImage} alt={''} className={styles.dishImage} />
                    </div>
                  )}
                  <h2>{dish?.name}</h2>
                </div>
                <button
                  className={styles.deleteButton}
                  onClick={() => handleRemoveProduct(dish.id)}
                >
                  <img className={styles.icon} src={trashGray} alt='icon' />
                </button>
              </div>
              <div className={styles.right}>
                <div className={styles.control}>
                  <CustomButton
                    className={styles.countButton}
                    title='-'
                    onClick={() =>
                      handleDecrease(
                        currentClaim?.order?.orderDetails?.find(
                          (item) => item.productId === dish.id,
                        ),
                      )
                    }
                  />
                  <input
                    min={1}
                    value={
                      currentClaim?.order?.orderDetails?.find((item) => item.productId === dish?.id)
                        ?.quantity === 0
                        ? ''
                        : currentClaim?.order?.orderDetails?.find(
                            (item) => item.productId === dish.id,
                          )?.quantity
                    }
                    onChange={(e) =>
                      onCountChange(
                        e,
                        currentClaim?.order?.orderDetails?.find(
                          (item) => item.productId === dish?.id,
                        ),
                      )
                    }
                    className={styles.countInput}
                  />
                  <CustomButton
                    className={styles.countButton}
                    title='+'
                    onClick={() =>
                      handleIncrease(
                        currentClaim?.order?.orderDetails?.find(
                          (item) => item.productId === dish.id,
                        ),
                      )
                    }
                  />
                </div>

                <h3 className={styles.priceText}>
                  {
                    currentClaim?.order?.orderDetails.find((item) => item.productId === dish.id)
                      ?.quantity
                  }
                  X{dish?.price} руб
                </h3>
              </div>
              {dish?.comment && <div className={styles.comment}>{dish?.comment}</div>}
              <span
                onClick={() => {
                  setSelectedProduct(dish)
                  setVisibleCreateComment(true)
                }}
                className={styles.addComment}
              >
                {dish?.comment ? 'Изменить комментарий' : 'Добавить комментарий'}
              </span>
            </div>
          ))}
        </div>

        {currentClaim?.order && currentClaim?.order?.orderDetails && (
          <div className={styles.orderInfoContainer}>
            <div className={styles.totalPriceContainer}>
              <span className={styles.totalPriceTitle}>Итоговая сумма заказа</span>
              <span className={styles.totalPrice}>{currentClaim?.order?.totalPrice} руб</span>
            </div>
            <div className={styles.moreContainer}>
              <div onClick={() => setOpenMore(!openMore)} className={styles.moreWrapper}>
                <img src={arrow} />
                <span className={styles.moreTitle}>{openMore ? 'Свернуть' : 'Подробнее'}</span>
              </div>
              {openMore && (
                <>
                  <div className={styles.moreItemInfo}>
                    <span className={styles.leftSide}>
                      Скидка {discount == currentClaim?.discountPercent ? discount : ''}
                      {discount == currentClaim?.discountPercent ? '%' : ''}
                    </span>
                    <span className={styles.rightSide}>{discountTotal} руб</span>
                  </div>
                  <div className={styles.moreItemInfo}>
                    <span className={styles.leftSide}>
                      Сервисный сбор{' '}
                      {serviceFee == currentClaim?.serviceFeePercent ? serviceFee : ''}
                      {serviceFee == currentClaim?.serviceFeePercent ? '%' : ''}
                    </span>
                    <span className={styles.rightSide}>{serviceFeeTotal} руб</span>
                  </div>
                  <div className={styles.moreItemInfo}>
                    <span className={styles.leftSide}>Стоимость аренды площадки</span>
                    <span className={styles.rightSide}>
                      {currentClaim?.place?.establishment?.rentCost} руб
                    </span>
                  </div>
                  <div className={styles.moreItemInfo}>
                    <span className={styles.leftSide}>Пробковый сбор </span>
                    <span className={styles.rightSide}>
                      {corkFee == currentClaim?.corkFeePercent ? corkFee : ''}
                      {corkFee == currentClaim?.corkFeePercent ? '%' : ''}
                    </span>
                  </div>
                  <div className={styles.moreItemInfo}>
                    <span className={styles.leftSide}>
                      Сумма заказа без учета скидок и сервисного сбора
                    </span>
                    <span className={styles.rightSide}>{currentClaim?.order?.price} руб</span>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        <div
          style={{ justifyContent: currentClaim.order.id ? 'space-between' : 'flex-end' }}
          className={styles.saveButtonBlock}
        >
          {currentClaim.order.id ? (
            <CustomButton
              disabled={!currentClaim.order?.orderDetails.length}
              className={styles.deleteBtn}
              title='Удалить заказ'
              type='button'
              onClick={handleDeleteOrder}
            />
          ) : (
            <div></div>
          )}
          <CustomButton
            disabled={!currentClaim.order?.orderDetails.length}
            className={styles.addSiteBtn}
            title='Сохранить'
            type='button'
            onClick={handleSubmit}
          />
        </div>
      </div>
    </div>
  )
}

export default OrderedDishesListCard
